import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSort, Sort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import {KeycloakService} from 'keycloak-angular';
import {LookupService} from 'src/app/modules/common/services/lookup.service';
import {HelpService} from 'src/app/modules/other/services/help.service';
import {NationalDrugFormularyService} from '../../../services/national-drug-formulary.service';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {NationalDrugFormularyDTO} from 'src/app/modules/pbm/models/NationalDrugFormularyDTO';
import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {NationalDrugDTO} from 'src/app/modules/pbm/models/NationalDrugDTO';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {TableControl} from 'src/app/modules/common/models/TableControl';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {NationalDrugService} from '../../../services/national-drug.service';
import {MatStepper} from '@angular/material/stepper';
import {debounceTime, Subject, takeUntil} from 'rxjs';
import {DateUtil} from 'src/app/modules/common/util/DateUtil';
import {MatTableDataSource} from '@angular/material/table';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {SharedService} from '../../../../common/services/shared-service';
import {detailsExpand} from '../../../../common';
import {Common, createFieldMap, getSortDirection, sortByPropertyAndDirection} from '../../../../common/util/Util';
import {EntRequestBuilder} from 'src/app/modules/ent/services/ent-request-builder';
import {FilterDataService} from 'src/app/modules/common/services/filter-data.service';
import {EntityTable} from 'src/app/modules/common/types/entity-table.enum';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';
import {NationalDrugFormularyLinkDTO} from '../../../models/NationalDrugFormularyLinkDTO';
import {PagedResponseDTO} from '../../../../common/models/PagedResponseDTO';
import {HelpInfo} from '../../../../clm/types/help-info.enum';

enum TableColumns {
  Select = 'select',
  NationalDrugCode = 'nationalDrugCode',
  BrandName = 'brandName',
  Ingredients = 'ingredients',
  Manufacturer = 'manufacturer',
  StartDate = 'startDate',
  EndDate = 'endDate',
}

@Component({
  selector: 'app-add-drug-formulary',
  templateUrl: './add-national-drug-formulary-view.component.html',
  styleUrls: [
    './add-national-drug-formulary-view.component.scss',
    '../../../../../../styles/global/_add-view-edit-styles.scss'
  ],
  animations: [detailsExpand]
})
export class AddNationalDrugFormularyViewComponent implements OnInit, AfterViewChecked, OnDestroy {
  readonly tableColumns = TableColumns;
  readonly filterDataValueTextChanged$ = new Subject<boolean>();
  readonly destroyed$ = new Subject();
  readonly lookupValue = LookupValue;

  nationalDrugDisplayedColumns: string[] = Object.values(TableColumns);
  nationalDrugDataSource: MatTableDataSource<NationalDrugDTO> = new MatTableDataSource();
  nationalDrugTableControl: TableControl;
  nationalDrugExpandedRow: NationalDrugDTO | null;
  showSelectedDrugs: boolean;

  @ViewChild('matSort', {static: false}) nationalDrugSort: MatSort;
  @ViewChild('nationalDrugPaginator') nationalDrugPaginator: MatPaginator;
  @ViewChild('stepper') private drugFormularyStepper: MatStepper;

  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  dateFormat = DateUtil.dateFormat;
  dateTimeFormat = DateUtil.dateTimeFormat;
  initialSelection = [];
  allowMultiSelect = true;
  selectionControl = new SelectionModel<NationalDrugDTO>(this.allowMultiSelect, this.initialSelection);

  drugFormGroup: FormGroup;
  detailFormGroup: FormGroup;

  nameFormControl: FormControl;
  classFormControl: FormControl;
  planFormControl: FormControl;
  startDateFormControl: FormControl;
  endDateFormControl: FormControl;

  classes: NameValueDTO[];
  helpInfo: HelpDTO[];
  selectedNationalDrugs: NationalDrugDTO[] = [];
  selectedNationalDrugFormularyLinkDTO: NationalDrugFormularyLinkDTO[] = [];
  editNationalDrugFormulary: NationalDrugFormularyDTO = new NationalDrugFormularyDTO();

  isEdit = false;
  heading: string;
  userFirstLastName = '';

  private fieldMapHashMap = {};

  constructor(
    private changeDetect: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private keycloakService: KeycloakService,
    private lookupService: LookupService,
    private nationalDrugFormularyService: NationalDrugFormularyService,
    private nationalDrugService: NationalDrugService,
    private helpService: HelpService,
    private sharedService: SharedService,
    private filterDataService: FilterDataService
  ) {
    this.nameFormControl = new FormControl('');
    this.classFormControl = new FormControl('');
    this.planFormControl = new FormControl(''); // TODO: implement in UI
    this.startDateFormControl = new FormControl('');
    this.endDateFormControl = new FormControl('');

    this.drugFormGroup = this.formBuilder.group({}, {validator: this.minimumDrugValidator()});

    this.detailFormGroup = this.formBuilder.group({
      name: this.nameFormControl,
      class: this.classFormControl,
      planName: this.planFormControl,
      startDate: this.startDateFormControl,
      endDate: this.endDateFormControl
    });

    this.nationalDrugTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'nationalDrugCode',
      'asc',
      'brandName',
      ''
    );

    this.showSelectedDrugs = false;
  }

  // TODO: Fix validator
  minimumDrugValidator(): { [key: string]: boolean } | null {
    if (this.selectedNationalDrugs != null && this.selectedNationalDrugs.length > 0) {
      return {minimumDrug: true};
    }
    return null;
  }

  ngOnInit(): void {
    this.initInstanceFieldsBasedOnRoute();
    this.initSubscriptions();

    this.getListOfLookupValues(this.lookupValue.FormularyClass);
    this.getHelpInfo(HelpInfo.NationalDrugFormulary);

    this.keycloakService.loadUserProfile().then((profile) => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  initInstanceFieldsBasedOnRoute(): void {
    this.isEdit = this.route.snapshot.url[1].path === 'edit-national-drug-formulary';

    if (this.isEdit) {
      this.showSelectedDrugs = true;
      this.heading = 'Edit a National Drug Formulary';
      this.route.paramMap.subscribe((params) => {
        this.getNationalDrugFormulary(Number(params.get('id')));
      });
    }
    else {
      this.getListOfNationalDrugsByPagedRequestDTO(this.getDefaultPagedRequestDTO(this.nationalDrugTableControl, false));
      this.updateNationalDrugFormularyName();
    }
  }

  initSubscriptions(): void {
    this.filterDataValueTextChanged$
      .pipe(
        takeUntil(this.destroyed$),
        debounceTime(Common.DEBOUNCE_TIME)
      )
      .subscribe(() => {
        const pagedRequestDTO = EntRequestBuilder.getPagedRequestDTO(this.nationalDrugTableControl, EntityTable.TblNationalDrug);
        pagedRequestDTO.fieldMap = this.fieldMapHashMap;
        this.getListOfNationalDrugsByPagedRequestDTO(pagedRequestDTO);
      });
  }

  getDefaultPagedRequestDTO(tableControl: TableControl, useExistingFieldMap: boolean): PagedRequestDTO {
    const pagedRequestDTO: PagedRequestDTO = {
      entityClass: EntityTable.TblNationalDrug,
      pageNumber: tableControl.pageNumber,
      pageSize: tableControl.pageSize,
      sortField: tableControl.sortField,
      sortDirection: getSortDirection(tableControl.sortDirection),
      fieldMap: useExistingFieldMap ? this.fieldMapHashMap : createFieldMap(tableControl.filterField, tableControl.filterValue)
    };

    return pagedRequestDTO;
  }

  getListOfNationalDrugsByPagedRequestDTO(pagedRequestDTO: PagedRequestDTO): void {
    this.nationalDrugService.getListOfNationalDrugs(pagedRequestDTO)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
      next: (response: PagedResponseDTO<NationalDrugDTO>) => {

        let nationalDrugsInTable = response.resultList;
        if (this.selectedNationalDrugFormularyLinkDTO?.length) {
          nationalDrugsInTable = nationalDrugsInTable.map((nationalDrug: NationalDrugDTO) => {
            const nationalDrugNetworkLinkDTOExist = this.selectedNationalDrugFormularyLinkDTO.find((item) => item.nationalDrug.nationalDrugId === nationalDrug.nationalDrugId);
            if (nationalDrugNetworkLinkDTOExist) {
              nationalDrug.nationalDrugFormularyStartDate = nationalDrugNetworkLinkDTOExist.startDate;
              nationalDrug.nationalDrugFormularyEndDate = nationalDrugNetworkLinkDTOExist.endDate;
            }
            else {
              nationalDrug.nationalDrugFormularyStartDate = null;
              nationalDrug.nationalDrugFormularyEndDate = null;
            }
            return nationalDrug;
          });
        }

        this.handleIngredientTooltip(nationalDrugsInTable);
        this.nationalDrugDataSource.data = nationalDrugsInTable;
        this.nationalDrugTableControl.length = response.totalRecords;
        this.updateNationalDrugSelectedOnPage();
      },
      error: (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    });
  }

  getNationalDrugFormulary(nationalDrugFormularyId: number): void {
    this.nationalDrugFormularyService.getNationalDrugFormulary(nationalDrugFormularyId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
      next: (response: NationalDrugFormularyDTO) => {
        this.editNationalDrugFormulary = response;

        // Note: Hacky Fix to Override the National Drug Start and End Date with Formulary Link Start and End Date
        this.selectedNationalDrugFormularyLinkDTO = response.nationalDrugs ?? [];
        this.selectedNationalDrugs = this.selectedNationalDrugFormularyLinkDTO ? this.selectedNationalDrugFormularyLinkDTO.map((item: NationalDrugFormularyLinkDTO) => {
          const nationalDrug: NationalDrugDTO = item.nationalDrug;
          const nationalDrugNetworkLinkDTOExist = this.selectedNationalDrugFormularyLinkDTO.find((item2) => item2.nationalDrug.nationalDrugId === nationalDrug.nationalDrugId);
          if (nationalDrugNetworkLinkDTOExist) {
            nationalDrug.nationalDrugFormularyStartDate = nationalDrugNetworkLinkDTOExist.startDate;
            nationalDrug.nationalDrugFormularyEndDate = nationalDrugNetworkLinkDTOExist.endDate;
          }
          else {
            nationalDrug.nationalDrugFormularyStartDate = null;
            nationalDrug.nationalDrugFormularyEndDate = null;
          }
          return nationalDrug;
        }) : [];

        this.populateForms();
        if (this.isEdit) {
          this.toggleShowSelectedDrugs(undefined);
        }
      },
      error: (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    });
  }

  populateForms(): void {
    this.nameFormControl.setValue(this.editNationalDrugFormulary.name);
    this.classFormControl.setValue(this.editNationalDrugFormulary.formularyClass.name);
    this.startDateFormControl.setValue(new Date(this.editNationalDrugFormulary.startDate));
    this.endDateFormControl.setValue(new Date(this.editNationalDrugFormulary.endDate));
    this.updateNationalDrugFormularyName();
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe({
      next: (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.FormularyClass) {
          this.classes = response;
        }
      },
     error: (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    });
  }

  getHelpInfo(componentName: string): void {
    this.helpService.getListOfHelpInfo(componentName).subscribe({
      next: (response) => {
        this.helpInfo = response;
      },
      error: (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    });
  }

  toggleShowSelectedDrugs(event: MatSlideToggleChange): void {
    this.showSelectedDrugs = event ? event.checked : this.showSelectedDrugs;

    if (this.showSelectedDrugs) {
      this.selectAllSelectedDrugs();
      this.nationalDrugDataSource = new MatTableDataSource<NationalDrugDTO>(this.filterSelectedDrugs());
      this.nationalDrugDataSource.sort = this.nationalDrugSort;
      this.nationalDrugDataSource.paginator = this.nationalDrugPaginator;
      this.updateSelectedDrugs();
    }
    else {
      this.nationalDrugDataSource = new MatTableDataSource();
      this.nationalDrugPaginator.length = this.nationalDrugTableControl.length;
      this.getListOfNationalDrugsByPagedRequestDTO(this.getDefaultPagedRequestDTO(this.nationalDrugTableControl, true));
    }
    this.nationalDrugPaginator?.firstPage();
    this.nationalDrugTableControl.pageNumber = 0;
  }

  onClickFinish(): void {
    const nationalDrugFormularyDTOPayload: NationalDrugFormularyDTO = this.getNationalDrugFormularyDTOPayload();
    this.nationalDrugFormularyService.saveNationalDrugFormulary(nationalDrugFormularyDTOPayload)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: () => {
          this.sharedService.openSnackBar(
            `National drug formulary ${nationalDrugFormularyDTOPayload.nationalDrugFormularyId} saved successfully`,
            'Dismiss'
          );
          this.router.navigate(['/pharmacy-management'], {queryParams: {tab: 'national-drug-formularies'}});
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage || 'Error occurred while saving National Drug Formulary');
        }
      });
  }

  isAllSelected(): boolean {
    if (this.nationalDrugDataSource != null) {
      const numSelected = this.selectionControl.selected.length;
      const numRows = this.nationalDrugDataSource.data.length;
      return numSelected === numRows;
    }
  }

  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selectionControl.clear();
    }
    else {
      this.selectAllInDataSource();
    }
  }

  private selectAllInDataSource(): void {
    this.selectionControl.clear();
    this.nationalDrugDataSource.data.forEach(
      (row) => this.selectionControl.select(row)
    );
  }

  private selectAllSelectedDrugs(): void {
    this.selectionControl.clear();
    this.selectedNationalDrugs.forEach(
      (row) => this.selectionControl.select(row)
    );
  }

  toggleSelect(toggleDrug: NationalDrugDTO): void {
    this.selectionControl.toggle(toggleDrug);
    this.updateSelectedDrugs();
  }

  isSelected(checkDrug: NationalDrugDTO): boolean {
    let found = false;

    if (this.selectionControl != null) {
      const foundDrug = this.selectionControl.selected.find(
        selectedDrug => selectedDrug.nationalDrugId === checkDrug.nationalDrugId
      );

      if (foundDrug != null) {
        found = true;
      }
    }

    return found;
  }

  pageChanged($event: PageEvent): void {
    this.updateSelectedDrugs();
    this.nationalDrugTableControl.pageNumber = $event.pageIndex;
    this.nationalDrugTableControl.pageSize = $event.pageSize;
    if (!this.showSelectedDrugs) {
      this.getListOfNationalDrugsByPagedRequestDTO(this.getDefaultPagedRequestDTO(this.nationalDrugTableControl, true));
    }
  }

  sortData($event: Sort): void {
    this.updateSelectedDrugs();
    this.nationalDrugPaginator.firstPage();
    this.nationalDrugTableControl.pageNumber = 0;
    if ($event.active === TableColumns.Manufacturer) {
      this.nationalDrugTableControl.sortField = 'manufacturerByManufacturerId.name';
    }
    else {
      this.nationalDrugTableControl.sortField = $event.active;
    }
    this.nationalDrugTableControl.sortDirection = $event.direction;

    if (!this.showSelectedDrugs) {
      this.getListOfNationalDrugsByPagedRequestDTO(this.getDefaultPagedRequestDTO(this.nationalDrugTableControl, true));
    }
    else {
      const propertyName = $event.active === 'manufacturer' ? 'manufacturer.name' : $event.active;
      this.nationalDrugDataSource = new MatTableDataSource(
        this.filterSelectedDrugs().sort(sortByPropertyAndDirection(propertyName, $event.direction))
      );
    }
  }

  onInputChangedFilterData(event: Event, filterField: string): void {
    this.updateSelectedDrugs();
    const filterValue = (event.target as HTMLInputElement).value;

    this.nationalDrugPaginator.firstPage();
    this.nationalDrugTableControl.pageNumber = 0;
    this.nationalDrugTableControl.filterField = filterField;
    this.nationalDrugTableControl.filterValue = filterValue;

    this.fieldMapHashMap = {... this.filterDataService.getFieldMapHashMap(filterField, filterValue, this.fieldMapHashMap)};

    if (!this.showSelectedDrugs) {
      this.filterDataValueTextChanged$.next(true);
    }
    else {
      this.nationalDrugDataSource = new MatTableDataSource<NationalDrugDTO>(this.filterSelectedDrugs());
    }
  }

  filterSelectedDrugs(): NationalDrugDTO[] {
    const filteredDrugs = this.filterDataService.filterSelectedItemsBasedOnFieldMap<NationalDrugDTO>(this.selectedNationalDrugs, this.fieldMapHashMap);
    this.handleIngredientTooltip(filteredDrugs);
    return filteredDrugs;
  }

  handleIngredientTooltip(nationalDrugs: NationalDrugDTO[]): void {
    nationalDrugs?.forEach((item: NationalDrugDTO) => {
      if (item.ingredients && item.ingredients?.length) {
        if (item.ingredients.length === 1) {
          item.ingredientsFirstTooltip = item.ingredients[0].name;
        }
        else {
          item.ingredientsFirstTooltip = item.ingredients[0].name + '...';
          item.ingredientsFullToolTip = item.ingredients?.map((ingredient) => ingredient.name).join(', ');
        }
      }
    });
  }

  updateSelectedDrugs(): void {

    if (this.nationalDrugDataSource == null || this.selectedNationalDrugs == null || !this.selectionControl.hasValue()) {
      return;
    }

    // 1. Remove all non-selected drugs on the page from the selectedNationalDrugs array

    // For each drug on the page
    this.nationalDrugDataSource.data.forEach(pageDrug => {

      // Check each selected drug in the formulary
      this.selectedNationalDrugs.forEach(selectedDrug => {
        let index = 0;
        let foundDrug = null;

        // If one of the drugs on the page is selected in the formulary
        if (selectedDrug.nationalDrugId === pageDrug.nationalDrugId) {

          // Find if that drug is selected in the page selection model
          foundDrug = this.selectionControl.selected.find(
            newSelectedDrug => selectedDrug.nationalDrugId === newSelectedDrug.nationalDrugId
          );

          // if it is not found, remove it
          if (foundDrug == null) {
            this.selectedNationalDrugs.splice(index);
          }
        }

        index++;
      });
    });

    // 2. Add all selected drugs if they aren't yet selected

    this.selectionControl.selected.forEach(newSelectedDrugToAdd => {
      const foundDrugToIgnore = this.selectedNationalDrugs.find(
        oldSelectedDrug => oldSelectedDrug.nationalDrugId === newSelectedDrugToAdd.nationalDrugId
      );

      if (foundDrugToIgnore == null) {
        this.selectedNationalDrugs.push(newSelectedDrugToAdd);
      }
    });
  }

  updateNationalDrugSelectedOnPage(): void {

    if (this.selectedNationalDrugs != null && this.nationalDrugDataSource != null) {
      this.nationalDrugDataSource.data.forEach(pageDrug => {
        const foundDrug = this.selectedNationalDrugs.find(
          (selectedDrug) => selectedDrug.nationalDrugId === pageDrug.nationalDrugId
        );
        if (foundDrug != null) {
          this.selectionControl.select(foundDrug);
        }
      });
    }
  }

  drugsClear(): void {
    this.selectionControl.clear();
    this.selectedNationalDrugs = [];
  }

  drugsNext(): void {
    this.updateSelectedDrugs();
    if (this.selectedNationalDrugs != null && this.selectedNationalDrugs.length > 0) {
      this.drugFormularyStepper.next();
    }
    else {
      this.sharedService.openSnackBar(
        'Select at least 1 national drug',
        'Dismiss'
      );
    }
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo != null) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo != null ? helpInfo.inputInfo : '';
    }
    return message;
  }

  onChangeInputFormularyName($event: Event): void {
    const targetValue = ($event.target as HTMLInputElement).value;
    this.nameFormControl.patchValue(targetValue);
    this.updateNationalDrugFormularyName();
  }

  private updateNationalDrugFormularyName(): void {
    if (this.isEdit) {
      this.heading = `Edit a National Drug Formulary - ${this.nameFormControl.value}`;
    }
    else {
      this.heading = `Add a National Drug Formulary - ${this.nameFormControl.value}`;
    }
  }

  private getNationalDrugFormularyDTOPayload(): NationalDrugFormularyDTO {
    return {
      name: this.nameFormControl.value,
      formularyClass: this.classes.find((item) => item.name === this.classFormControl.value),
      startDate: this.startDateFormControl.value,
      endDate: this.endDateFormControl.value,
      nationalDrugFormularyId: this.isEdit ? this.editNationalDrugFormulary.nationalDrugFormularyId : null,
      updated: this.isEdit ? new Date() : null,
      updatedBy: this.isEdit ? this.userFirstLastName : null,
      created: this.isEdit ? this.editNationalDrugFormulary.created : new Date(),
      createdBy: this.isEdit ? this.editNationalDrugFormulary.createdBy : this.userFirstLastName,
      nationalDrugs: this.getNationalDrugsFormularyLinkDTOPayload()
    } as NationalDrugFormularyDTO;
  }

  private getNationalDrugsFormularyLinkDTOPayload(): NationalDrugFormularyLinkDTO[] {
    const nationalDrugFormularyLinkList: NationalDrugFormularyLinkDTO[] = this.selectedNationalDrugs.map((nationalDrug: NationalDrugDTO) => {
      const nationalDrugFormularyLinkDTOExist = this.selectedNationalDrugFormularyLinkDTO.find((item) => item.nationalDrug.nationalDrugId === nationalDrug.nationalDrugId);
      if (nationalDrugFormularyLinkDTOExist) {
        return this.getNationalDrugFormularyLinkDTOPayload(nationalDrug, nationalDrugFormularyLinkDTOExist);
      }
      else {
        return this.getNationalDrugFormularyLinkDTOPayload(nationalDrug);
      }
    });
    return nationalDrugFormularyLinkList;
  }

  private getNationalDrugFormularyLinkDTOPayload(nationalDrug: NationalDrugDTO, nationalDrugFormularyLinkDTO?: NationalDrugFormularyLinkDTO): NationalDrugFormularyLinkDTO {
    let payload: NationalDrugFormularyLinkDTO;

    const isProviderAlreadyExistedInList = !!nationalDrugFormularyLinkDTO; // save original start and end dates
    let originalStartDate;
    let originalEndDate;

    if (isProviderAlreadyExistedInList) {
      originalStartDate = nationalDrugFormularyLinkDTO.startDate;
      originalEndDate = nationalDrugFormularyLinkDTO.endDate;
    }

    payload = {
      nationalDrug,
      startDate: isProviderAlreadyExistedInList ? originalStartDate : (nationalDrug.startDate != null ? new Date(nationalDrug.startDate) : null),
      endDate: isProviderAlreadyExistedInList ? originalEndDate : (nationalDrug.endDate != null ? new Date(nationalDrug.endDate) : null),
    } as NationalDrugFormularyLinkDTO;

    return payload;
  }

}
